import React, { useMemo } from 'react';
import { LocationUrlProvider } from '@cp/shared/location';
import { Link } from '@cp/ds/src/components/link';
import { LocationOutlineIcon } from '@cp/ds/src/icons';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { getResumeAddress, getResumeGeoPoint } from '../model';

export interface AuthorLocationProps {
  provider: LocationUrlProvider;
  data: CatalogItemViewModel;
}

export const AuthorLocationLink: React.FC<AuthorLocationProps> = ({ provider, data }) => {
  const href = useMemo(() => {
    const geoPoint = getResumeGeoPoint(data);
    return geoPoint ? String(provider(geoPoint)) : undefined;
  }, [data, provider]);
  const address = useMemo(() => getResumeAddress(data), [data]);

  return (
    <Link external href={href} sx={{ display: 'inline-flex', alignItems: 'center' }}>
      <LocationOutlineIcon /> {address}
    </Link>
  );
};
